import React from 'react';


// HOC 傳回的除了是新的class也可以只是一個functional component，
// 就像component可以宣告成class，也可以只是stateless functional component

// 注入取得語言資料能力
// 傳回賦與能力的新SFC
// HOC會建立一個新的物件包住傳入元件，所以會消耗額外的資源
// 因此不應該大量使用，而是應該在適當的層級使用
// 例如在適當層級元件使用HOC注入語言資料，再由該元件往下傳遞語言資料
// 而不是在每個元件都用HOC注入語後資料
export default (Component) => (props) => {
   const { languageData, languageCode } = window.myConsts;

   const languageInjectedProps = { languageData, languageCode, ...props };

   return <Component {...languageInjectedProps} />;
};


// WEBPACK FOOTER //
// ./src/helpers/HOCLanguageInjector.js